<div class="container-fluid d-flex flex-column justify-content-center align-items-center">
  <img src="assets/chapps-logo.png"/>
  <mdb-card id="login-card" class="m-3">
      <mdb-card-body class="pb-2">
        <h5 appTitle id="app-name" class="text-center mb-4" [translate]="Localization.LoginTitle"></h5>
        <form #form="ngForm">
          <input type="email" id="emailInput" name="emailInput" class="form-control mb-4" (focus)="onInputFocus()" (keydown.enter)="onSubmit()"
                 [(ngModel)]="model.username"
                 [placeholder]="Localization.Email | translate">
          <input type="password" id="passwordInput" name="passwordInput" class="form-control mb-2" (focus)="onInputFocus()" (keydown.enter)="onSubmit()"
                 [(ngModel)]="model.password"
                 [placeholder]="Localization.Password | translate">
          <mdb-checkbox [inline]="true"
              [checked]="model.keepMeLoggedIn"
              (change)="onKeepMeLoggedInChange($event.checked)">
              <span [translate]="Localization.KeepMeLoggedIn"></span>
            </mdb-checkbox>
        </form>
        <div *ngIf="isWrongCredentialsAlertVisible" 
             class="alert alert-danger mb-0" 
             role="alert"
             data-cy="invalidCredentialsError"
             [translate]="Localization.WrongEmailOrPassword">
        </div>
        <div *ngIf="isUnConfirmedAccountAlertVisible" class="alert alert-danger mb-0" role="alert"
        [translate]="Localization.UnconfirmedAccount">
   </div>
      </mdb-card-body>
      <mdb-card-footer class="text-center">
        <button *ngIf="!isProccessing" type="button" class="mb-2"
                     data-cy="signIn"
                     mdbBtn
                     appBg="primary"
                     brightness="normal"
                     appTextColor="primary"
                     [block]="true"
                     (click)="onSubmit()"
                     mdbWavesEffect
                     [translate]="Localization.Login">
        </button>
        <div class="d-flex justify-content-between">
            <div>
              <button *ngIf="!isProccessing && registrationUrl != null"
                  class="px-md-0 btn btn-link"
                  (click)="redirectToRegisterForm()"
                  [translate]="Localization.CreateAccount">
              </button>
            </div>
            <button *ngIf="!isProccessing"
                data-cy="passwordReset"
                class="px-md-0 btn btn-link"
                (click)="goToResetPasswordPage()"
                [translate]="Localization.ForgotPassword">
            </button>
        </div>
        <mdb-spinner *ngIf="isProccessing"></mdb-spinner>
      </mdb-card-footer>
  </mdb-card>
</div>

